export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_AUTHENTICATION = 'SET_AUTHENTICATION';
export const SET_USER = 'SET_USER';
export const SET_FACILITIES = 'SET_FACILITIES';
export const SET_TASKS_MANAGER = 'SET_TASKS_MANAGER';
export const SET_MEDIA_INFO = 'SET_MEDIA_INFO';
export const SET_ORGANIZATION_ID = 'SET_ORGANIZATION_ID';
export const SET_FACILITY_NAME = 'SET_FACILITY_NAME';
